"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUserFriendlyErrorMessage = exports.extractIntegrationAppErrorData = exports.getErrorFromData = exports.AccessDeniedError = exports.NotAuthenticatedError = exports.NotFoundError = exports.ConnectionError = exports.FlowRunError = exports.FlowConfigurationError = exports.BadRequestError = exports.InternalError = exports.IntegrationAppError = exports.ErrorData = exports.isIntegrationAppError = exports.ConnectionErrorKey = exports.BadRequestErrorKey = exports.ErrorType = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./error-doc-enum"), exports);
var ErrorType;
(function (ErrorType) {
    ErrorType["BAD_REQUEST"] = "bad_request";
    ErrorType["CONNECTION"] = "connection";
    ErrorType["FLOW_CONFIGURATION"] = "flow_configuration";
    ErrorType["FLOW_RUN"] = "flow_run";
    ErrorType["INTERNAL"] = "internal";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
var BadRequestErrorKey;
(function (BadRequestErrorKey) {
    BadRequestErrorKey["NOT_FOUND"] = "not_found";
    BadRequestErrorKey["NOT_AUTHENTICATED"] = "not_authenticated";
    BadRequestErrorKey["ACCESS_DENIED"] = "access_denied";
    BadRequestErrorKey["ALREADY_EXISTS"] = "already_exists";
})(BadRequestErrorKey = exports.BadRequestErrorKey || (exports.BadRequestErrorKey = {}));
var ConnectionErrorKey;
(function (ConnectionErrorKey) {
    ConnectionErrorKey["CONNECTION_IS_DEFUNCT"] = "connection_is_defunct";
    ConnectionErrorKey["ACCESS_TOKEN_EXPIRED"] = "access_token_expired";
    ConnectionErrorKey["RATE_LIMIT_EXCEEDED"] = "rate_limit_exceeded";
})(ConnectionErrorKey = exports.ConnectionErrorKey || (exports.ConnectionErrorKey = {}));
function isIntegrationAppError(error) {
    return error && error.isIntegrationAppError;
}
exports.isIntegrationAppError = isIntegrationAppError;
class ErrorData {
    constructor(arg) {
        if (arg instanceof Error) {
            this.message = arg.message;
            this.stack = arg.stack;
            this.type = ErrorType.INTERNAL;
        }
        else if (typeof arg === 'string') {
            this.message = arg;
            this.type = ErrorType.INTERNAL;
        }
        else if (typeof arg === 'object' && arg !== null) {
            Object.assign(this, arg);
        }
        else {
            throw new Error('Invalid argument when creating BaseErrorData: ' + JSON.stringify(arg));
        }
    }
}
exports.ErrorData = ErrorData;
class IntegrationAppError extends Error {
    constructor(arg) {
        const errorData = new ErrorData(arg);
        super(errorData.message);
        this.isIntegrationAppError = true;
        this.data = errorData;
        if (!this.data.type) {
            this.data.type = ErrorType.INTERNAL;
        }
        if (typeof window !== 'undefined') {
            this.message = buildUserFriendlyErrorMessage(this.data);
        }
    }
}
exports.IntegrationAppError = IntegrationAppError;
class InternalError extends IntegrationAppError {
    constructor(arg) {
        super(arg);
        this.data.type = ErrorType.INTERNAL;
    }
}
exports.InternalError = InternalError;
class BadRequestError extends IntegrationAppError {
    constructor(arg) {
        super(arg);
        this.data.type = ErrorType.BAD_REQUEST;
    }
}
exports.BadRequestError = BadRequestError;
class FlowConfigurationError extends BadRequestError {
    constructor(arg) {
        super(arg);
        this.data.type = ErrorType.FLOW_CONFIGURATION;
    }
}
exports.FlowConfigurationError = FlowConfigurationError;
class FlowRunError extends IntegrationAppError {
    constructor(arg) {
        super(arg);
        this.data.type = ErrorType.FLOW_RUN;
    }
}
exports.FlowRunError = FlowRunError;
class ConnectionError extends IntegrationAppError {
    constructor(arg) {
        super(arg);
        this.data.type = ErrorType.CONNECTION;
    }
}
exports.ConnectionError = ConnectionError;
class NotFoundError extends BadRequestError {
    constructor(arg) {
        super(arg);
        this.data.key = BadRequestErrorKey.NOT_FOUND;
    }
}
exports.NotFoundError = NotFoundError;
class NotAuthenticatedError extends BadRequestError {
    constructor(arg) {
        super(arg);
        this.data.key = BadRequestErrorKey.NOT_AUTHENTICATED;
    }
}
exports.NotAuthenticatedError = NotAuthenticatedError;
class AccessDeniedError extends BadRequestError {
    constructor(arg) {
        super(arg);
        this.data.key = BadRequestErrorKey.ACCESS_DENIED;
    }
}
exports.AccessDeniedError = AccessDeniedError;
const ERROR_CLASS_BY_TYPE = {
    [ErrorType.BAD_REQUEST]: BadRequestError,
    [ErrorType.CONNECTION]: ConnectionError,
    [ErrorType.FLOW_CONFIGURATION]: FlowConfigurationError,
    [ErrorType.FLOW_RUN]: FlowRunError,
    [ErrorType.INTERNAL]: InternalError,
};
function getErrorFromData(data) {
    if (typeof data === 'object' &&
        data !== null &&
        Object.values(ErrorType).includes(data.type) &&
        data.type in ERROR_CLASS_BY_TYPE) {
        return new ERROR_CLASS_BY_TYPE[data.type](data);
    }
    return null;
}
exports.getErrorFromData = getErrorFromData;
function extractIntegrationAppErrorData(error) {
    const data = error.isIntegrationAppError
        ? error.data
        : new ErrorData({
            message: error.message,
            type: ErrorType.INTERNAL,
        });
    if (!data.message) {
        data.message = error.message;
    }
    if (!data.stack) {
        data.stack = error.stack;
    }
    return data;
}
exports.extractIntegrationAppErrorData = extractIntegrationAppErrorData;
function buildUserFriendlyErrorMessage({ type, message, doc, }) {
    const docsLink = !doc
        ? ''
        : `https://console.integration.app/docs/errors/${doc}`;
    return `[Integration.app Error] (${type}) \n"${message}" \n${docsLink}`;
}
exports.buildUserFriendlyErrorMessage = buildUserFriendlyErrorMessage;
//# sourceMappingURL=index.js.map